export const CustomerPaymentColumns = [
  {
    id: "customer_payment_actions",
    title: "Actions",
  },
  {
    id: "invoice_no",
    title: "Invoice No",
  },
  {
    id: "customerId",
    title: "Customer Name",
  },
  {
    id: "payment_type",
    title: "Payment Type", // Will show either "Cash" or "Bank" (1 or 2)
  },
  {
    id: "bank_name",
    title: "Bank Name",
  },
  {
    id: "bank_number",
    title: "Bank Number",
  },
  {
    id: "desc",
    title: "Description",
  },
  {
    id: "amount",
    title: "Amount",
  },
  {
    id: "date",
    title: "Date",
  },
];
